module.exports = __webpack_public_path__ + "img/icon_notice.2d0afaff.png";